export default {
     BRA: 'pt-BR'
}